import { render, staticRenderFns } from "./GiptForm.vue?vue&type=template&id=0fc83890&scoped=true&"
import script from "./GiptForm.vue?vue&type=script&lang=ts&"
export * from "./GiptForm.vue?vue&type=script&lang=ts&"
import style0 from "./GiptForm.vue?vue&type=style&index=0&id=0fc83890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc83890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VForm,VIcon,VRow,VSimpleTable})
